import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import _ from "i18n";

import { TREE_TYPES, TREE_TABS } from "Config";
import { fetchBudgetTree } from "Thunks";
import { setFilterCollaboratorRole, setFilterCollaborators } from "Actions";

import { Button } from "antd";
import { ICONS, ArrowLeftIcon } from "../Common/Icons";
import PageHeader from "../Common/PageHeader/PageHeader";
import NotFoundV2 from "../NotFound/NotFoundV2";
import TreeTable from "../Common/Tables/TreeTable";
import BudgetSheetFilter from "../BudgetSheetFilter/BudgetSheetFilter";

import styles from "./BudgetTree.local.scss";
import { NotificationBar } from "../Common/Notification/NotificationBar";
import { inIframe } from "../../utils";

const tabs = [
  {
    code: TREE_TABS.ALL_FOLDERS,
    label: "allClients",
    roles: [TREE_TABS.ALL_FOLDERS]
  },
  {
    code: TREE_TABS.MY_FOLDERS,
    label: "myClients",
    roles: [TREE_TABS.MY_FOLDERS]
  },
  {
    code: TREE_TABS.OTHER_FOLDERS,
    label: "otherClients",
    roles: [TREE_TABS.OTHER_FOLDERS]
  }
];

class BudgetTree extends PureComponent {
  //******************   Content Functions  **************//

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      filterFormIsVisible: false,
      isCollaboratorTabsVisible: false,
      selectedTab: "ALL",
      loading: false
    };
  }

  // //******************   Content Functions END  **************//

  //******************   Content Render functions  ****************//
  renderBudget = () => {
    const { budgetData, erpData } = this.props;
    let dataYears, dataModel;

    dataYears = budgetData.periods;
    dataModel = budgetData.budget;

    const data = dataModel ? dataModel : [];
    const columns = [
      { name: _("name"), basis: "350px", grow: "1" },
      ...(dataYears && dataYears.length > 0
        ? dataYears.map(dataYear => ({
            name: _(dataYear),
            basis: "150px",
            grow: "1"
          }))
        : [])
    ];
    return data.length === 0 ? (
      <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        text={_("noTimeSheetMatches")}
        buttonIgnored={true}
      />
    ) : (
      <TreeTable
        expandAll={true}
        dataSource={data}
        erpData={erpData}
        periods={dataYears}
        columns={columns}
        filter={this.props.budgetSheetFilter}
        types={[TREE_TYPES.RESPONSIBLE, TREE_TYPES.DELEGATED]}
        handleReOpenTree={this.handleReOpenBudgetTree.bind(this)}
      />
    );
  };

  handleReOpenBudgetTree = (type, id, label) => {
    const { dispatch } = this.props;

    dispatch(
      setFilterCollaborators([
        {
          value: id.split("_")[1],
          label,
          color: "#000000"
        }
      ])
    );
    dispatch(setFilterCollaboratorRole(type));
    dispatch(fetchBudgetTree());
    this.setState({ isCollaboratorTabsVisible: true });
  };

  renderCollaboratorTabs = () => {
    const { role } = this.props;

    return (
      <div className={styles.filter_tabs}>
        {tabs.map(({ code, label, roles }) => (
          <div
            key={code}
            className={
              styles.filter_tabs_tab +
              " " +
              (role === code ? styles.filter_tabs_tab_active : "")
            }
            onClick={() => this.toggleCollaboratorTab(code, label, roles)}
          >
            <span>{_(label)}</span>
          </div>
        ))}
      </div>
    );
  };

  toggleCollaboratorTab = value => {
    const { dispatch } = this.props;

    dispatch(setFilterCollaboratorRole(value));
    dispatch(fetchBudgetTree());
  };

  handleRedirectBack = () => {
    this.props.dispatch(goBack());
  };

  renderBudgetCallout = error => {
    switch (error.code) {
      case 170010:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noOrganization")}
            buttonIgnored={true}
          />
        );
      case 170040:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("error1")}
            buttonIgnored={true}
          />
        );
      case 170041:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noBudget")}
            buttonIgnored={true}
          />
        );

      default:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("errorOccured")}
            buttonIgnored={true}
          />
        );
    }
  };

  componentWillUnmount() {
    clearTimeout(this.intervalID);
  }

  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  render() {
    const { fetching, fetched, error, collaborators } = this.props;
    const { isCollaboratorTabsVisible } = this.state;
    let oneSelectedCollaborator = collaborators.length === 1;

    return (
      <div>
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <PageHeader
          header={_("budget-sheet")}
          subHeader={_("subTitleBudgetSheet")}
          icon={ICONS.BUDGET_PAGE_ICON}
        />

        <div className={styles.resizable}>
          {/***************  BudgetSheet sheet viewer body *************/}
          <div>
            <div className="ttp-tab-container">
              <div className="rmodal__center">
                {oneSelectedCollaborator &&
                  isCollaboratorTabsVisible && (
                    <div className={styles.title_bar}>
                      <Button
                        key="cancel"
                        style={{
                          height: 36,
                          width: 36,
                          padding: 0,
                          alignItems: "center",
                          color: "#6D7F92",
                          background: "transparent",
                          display: "flex",
                          textAlign: "center",
                          justifyContent: "space-around",
                          border: "1px solid rgba(109, 127, 146, 0.2)",
                          boxSizing: "border-box",
                          borderRadius: "5px",
                          boxShadow: "0px 4px 4px rgba(41, 57, 77, 0.05)",
                          top: -5,
                          right: -120
                        }}
                        onClick={() => this.handleRedirectBack()}
                      >
                        <ArrowLeftIcon />
                      </Button>
                      <span className={styles.title_bar_title}>
                        {_("detailedBudget")} {collaborators[0].label}
                      </span>
                    </div>
                  )}
                <BudgetSheetFilter
                  customAddOn={
                    oneSelectedCollaborator &&
                    isCollaboratorTabsVisible &&
                    this.renderCollaboratorTabs()
                  }
                  filterFormIsVisible={this.handleFilterFormIsVisible}
                />

                <div>
                  {fetching ? (
                    <div className={styles.ripple_loading}>
                      <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                    </div>
                  ) : (
                    fetched &&
                    (!fetching && error
                      ? this.renderBudgetCallout(error)
                      : this.renderBudget())
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.budget.tree.fetching,
  fetched: state.budget.tree.fetched,
  budgetSheetFilter: state.budget.filter,
  error: state.budget.tree.error,
  budgetData: state.budget.tree.budgetData,
  role: state.budget.filter.collaborator.role,
  collaborators: state.budget.filter.collaborator.selected,
  currentOrganization: state.auth.currentOrganization,
  erpData: state.erpData.data.items
});

export default connect(mapStateToProps)(BudgetTree);



// WEBPACK FOOTER //
// ./src/components/Budget/BudgetTree.js